import React from "react";
import type { Presence } from "./types";
import { formatLastSeen } from "./utils";

export function PresenceDot({ online, status }: { online: boolean; status?: string }) {
    let color = "bg-neutral-600";
    if (online) {
        if (status === "typing") color = "bg-yellow-400 animate-pulse";
        else if (status === "away") color = "bg-orange-400";
        else if (status === "dnd") color = "bg-red-400";
        else color = "bg-teal-400";
    }

    return (
        <span
            className={`inline-block h-2.5 w-2.5 rounded-full ${color}`}
            aria-label={online ? "Online" : "Offline"}
            title={online ? "Online" : "Offline"}
        />
    );
}

export function ChatPresenceBadge({ p, status, incognito }: { p?: Presence; status?: string; incognito?: boolean }) {
    if (incognito || p?.incognito) {
        return (
            <div className="bs-presence-badge bs-presence-incognito flex items-center gap-2">
                <span className="bs-presence-dot inline-block h-2.5 w-2.5 rounded-full bg-cyan-400" aria-label="Incognito" title="Incognito" />
                <span className="bs-presence-label text-xs text-cyan-300">Incognito</span>
            </div>
        );
    }

    const online = Boolean(p?.online);
    let displayText = p?.hidden ? "Last seen unavailable" : online ? "Online" : formatLastSeen(p?.lastSeen);

    if (p?.typing) displayText = "Typing...";
    else if (status === "away") displayText = "Away";
    else if (status === "dnd") displayText = "Do Not Disturb";

    return (
        <div className="bs-presence-badge flex items-center gap-2">
            <PresenceDot online={online} status={status} />
            <span className="bs-presence-label text-xs text-neutral-400">{displayText}</span>
        </div>
    );
}
